import { Navigate, Outlet, useSearchParams } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { mustSetPassword } from "@/types/auth";

const DASHBOARD_PATH = "/dashboard";

function AuthLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-whart-bg text-sm text-neutral-500">
      Chargement…
    </div>
  );
}

export function GuestRoute() {
  const { user, isLoading, isStaff } = useAuth();
  const [searchParams] = useSearchParams();

  if (isLoading) {
    return <AuthLoading />;
  }

  if (user && isStaff) {
    if (mustSetPassword()) {
      return <Navigate to="/set-password" replace />;
    }

    const redirectTo = searchParams.get("redirectTo");
    const destination =
      redirectTo?.startsWith("/") && redirectTo !== "/login"
        ? redirectTo
        : DASHBOARD_PATH;

    return <Navigate to={destination} replace />;
  }

  return <Outlet />;
}
